/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown> }} Usage_Status_Headline_UncappedInputs */



/**
* | output |
* | --- |
* | "You've spent {used} this billing period." |
*
* @param {Usage_Status_Headline_UncappedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_status_headline_uncapped = /** @type {((inputs: Usage_Status_Headline_UncappedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Status_Headline_UncappedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie haben in dieser Abrechnungsperiode ${i?.used} ausgegeben.`)
	return /** @type {LocalizedString} */ (`You've spent ${i?.used} this billing period.`)
});